import { Playground } from '../../../components/playground/Playground';
import { PlaygroundColors } from '../../../components/playground/PlaygroundColors';
import { PlaygroundClasses } from '../../../components/playground/PlaygroundClasses';
import { Description } from '../../../components/Description';
import { colors, getColorNames } from '../../../utils/colors';
import Divider from '@rio-cloud/rio-uikit/Divider';

export const ProgressBars = () => (
    <div>
        <Description headline='Progress bars' anchor='progress' />
        <Playground
            example={progressbarExamples}
            classes={progressbarClasses}
            availableColors={<PlaygroundColors bgPrimary bgSecondary bgInfo bgSuccess bgWarning bgDanger />}
        />
    </div>
);

const eachColor = getColorNames(colors.brand, colors.status) as string[];

const progressbarExamples = (
    <>
        <div className='display-grid grid-cols-1 grid-cols-2-ls grid-cols-4-md gap-20'>
            <div>
                <h5>Standard</h5>
                {eachColor.map((color, index) => (
                    <div className='progress margin-bottom-20' key={crypto.randomUUID()}>
                        <div
                            className={`progress-bar progress-bar-${color}`}
                            style={{ width: `${(index + 1) * 10}%` }}
                        />
                    </div>
                ))}
            </div>

            <div>
                <h5>Striped</h5>
                {eachColor.map((color, index) => (
                    <div className='progress margin-bottom-20' key={crypto.randomUUID()}>
                        <div
                            className={`progress-bar progress-bar-striped progress-bar-${color}`}
                            style={{ width: `${(index + 1) * 10}%` }}
                        />
                    </div>
                ))}
            </div>

            <div>
                <h5>Animated</h5>
                {eachColor.map((color, index) => (
                    <div className='progress margin-bottom-20' key={crypto.randomUUID()}>
                        <div
                            className={`progress-bar progress-bar-striped progress-bar-animated progress-bar-${color}`}
                            style={{ width: `${(index + 1) * 10}%` }}
                        />
                    </div>
                ))}
            </div>

            <div>
                <h5>Indeterminate</h5>
                {eachColor.slice(0, -1).map(color => (
                    <div className='progress margin-bottom-20' key={crypto.randomUUID()}>
                        <div className={`progress-bar progress-bar-indeterminate progress-bar-${color}`} />
                    </div>
                ))}

                <div className='progress margin-bottom-20 width-50pct'>
                    <div
                        className='progress-bar progress-bar-indeterminate progress-bar-danger'
                        style={{ '--indeterminate-width': '40px' } as React.CSSProperties}
                    />
                </div>
            </div>
        </div>

        <h5>Stacked</h5>
        <div className='bs-component'>
            <div className='progress'>
                <div className='progress-bar progress-bar-success progress-divider' style={{ width: '35%' }} />
                <div className='progress-bar progress-bar-warning progress-divider' style={{ width: '20%' }} />
                <div
                    className='progress-bar progress-bar-info progress-divider progress-bar-striped progress-bar-animated'
                    style={{ width: '10%' }}
                />
            </div>
        </div>

        <h5 className='margin-top-25'>Stacked ratings</h5>
        <div className='bs-component'>
            <div className='progress'>
                <div className='progress-bar bg-rating-1 progress-divider' style={{ width: '15%' }} />
                <div className='progress-bar bg-rating-2 progress-divider' style={{ width: '20%' }} />
                <div className='progress-bar bg-rating-3 progress-divider' style={{ width: '25%' }} />
                <div className='progress-bar bg-rating-4 progress-divider' style={{ width: '15%' }} />
                <div className='progress-bar bg-rating-5 progress-divider' style={{ width: '25%' }} />
            </div>
        </div>

        <Divider className='margin-top-25' />

        <h5>Stacked ratings with custom icon overlay</h5>
        <div>
            <div className='display-flex justify-content-between'>
                <label>Poor</label>
                <label>Excelent</label>
            </div>
            <div className='position-relative'>
                <div className='progress'>
                    <div className='progress-bar bg-rating-1 progress-divider' style={{ width: '15%' }} />
                    <div className='progress-bar bg-rating-2 progress-divider' style={{ width: '20%' }} />
                    <div className='progress-bar bg-rating-3 progress-divider' style={{ width: '25%' }} />
                    <div className='progress-bar bg-rating-4 progress-divider' style={{ width: '15%' }} />
                    <div className='progress-bar bg-rating-5 progress-divider' style={{ width: '25%' }} />
                </div>
                <span
                    className='
                            bg-success
                            rounded-circle
                            border border-color-white border-width-2
                            shadow-accent
                            width-25
                            height-25
                            position-absolute
                            top-50pct
                            translate-x-50pct-y-50pct
                            display-grid place-items-center'
                    style={{ left: '65%' }}
                >
                    <span className='rioglyph rioglyph-truck' />
                </span>
            </div>
        </div>
    </>
);

const progressbarClasses = (
    <>
        <PlaygroundClasses label='Wrapper' classes='progress' />
        <PlaygroundClasses label='Base' classes='progress-bar' />
        <PlaygroundClasses
            label='Variants'
            prefix='progress-'
            classes={['animated', 'striped', 'indeterminate', 'divider']}
        />
        <PlaygroundClasses label='Colors' prefix='progress-bar-' classes={eachColor} />
    </>
);
